
import React from "react";
import { Small } from "@/components/ui/typography";

interface FormLabelProps {
  htmlFor: string;
  children: React.ReactNode;
}

const FormLabel = ({ htmlFor, children }: FormLabelProps) => (
  <Small weight="medium" className="text-mono-seasalt block mb-1.5">
    {children}
  </Small>
);

export default FormLabel;
